// The screens every tab leads to. Each screen's own slice fills it:
// Live lives in live/Live (the conversation, the workers, the gate);
// the rest are built in their own slices.
import type { JSX } from "solid-js";
import { t } from "@/i18n";

export { Live } from "@/live/Live";
export { Talk } from "@/talk/Talk";

function Screen(title: string, note: string): JSX.Element {
  return (
    <section class="screen">
      <h1>{title}</h1>
      <p>{note}</p>
    </section>
  );
}

export function Connections(): JSX.Element {
  return Screen(t("tab.connections", "Connections"), t("screen.placeholder", "This screen is built in its own slice."));
}

export function Machines(): JSX.Element {
  return Screen(t("tab.machines", "Machines"), t("screen.placeholder", "This screen is built in its own slice."));
}

export function Notes(): JSX.Element {
  return Screen(t("tab.notes", "Notes"), t("screen.placeholder", "This screen is built in its own slice."));
}

export function Files(): JSX.Element {
  return Screen(t("tab.files", "Files"), t("screen.placeholder", "This screen is built in its own slice."));
}

export function Settings(): JSX.Element {
  return Screen(t("tab.settings", "Settings"), t("screen.placeholder", "This screen is built in its own slice."));
}
